module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2n6n9r-ad01fb99685316486ee5937be802f9a7.svg";